import { render } from "./SyHome.vue?vue&type=template&id=c953f1fc&scoped=true"
import script from "./SyHome.vue?vue&type=script&lang=js"
export * from "./SyHome.vue?vue&type=script&lang=js"

import "./SyHome.vue?vue&type=style&index=0&id=c953f1fc&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c953f1fc"]])

export default __exports__